import CreateAgentDialog from './CreateAgentDialog';
import EditDistributorNameDialog from './EditDistributorNameDialog';

export default function Dialog() {
  return (
    <>
      <CreateAgentDialog />
      <EditDistributorNameDialog />
    </>
  );
}
